// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"466":"ae4e0114","496":"ab2a0014","584":"86b879ce","681":"f3c282f9","776":"4c3eae38","879":"490f6319"}[chunkId] + ".css";
};